import React from 'react';
import { TrendingUp, TrendingDown, Info } from 'lucide-react';
import { cryptoRecommendations } from '../../data/cryptoRecommendations';
import type { CryptoRecommendation } from '../../types/crypto';

interface CryptoListProps {
  selectedCategory: string;
  onSelectCrypto: (crypto: CryptoRecommendation) => void;
}

export function CryptoList({ selectedCategory, onSelectCrypto }: CryptoListProps) {
  const filteredCryptos = selectedCategory === 'all'
    ? cryptoRecommendations
    : cryptoRecommendations.filter(crypto => crypto.category === selectedCategory);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {filteredCryptos.map((crypto) => (
        <div
          key={crypto.symbol}
          className="bg-gray-900 rounded-xl p-6 border border-gray-800 hover:border-blue-500/50 transition-colors cursor-pointer"
          onClick={() => onSelectCrypto(crypto)}
        >
          <div className="flex justify-between items-start mb-4">
            <div>
              <h3 className="text-xl font-bold text-white">{crypto.name}</h3>
              <p className="text-sm text-gray-400">{crypto.symbol}</p>
            </div>
            <div className="text-right">
              <div className="text-sm text-gray-400">Market Cap</div>
              <div className="font-mono">${(crypto.marketCap / 1_000_000).toFixed(1)}M</div>
            </div>
          </div>

          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <div className="text-sm text-gray-400">24h Change</div>
              <div className={`flex items-center gap-1 ${
                parseFloat(crypto.priceHistory.yearToDateChange) > 0
                  ? 'text-green-400'
                  : 'text-red-400'
              }`}>
                {parseFloat(crypto.priceHistory.yearToDateChange) > 0 ? (
                  <TrendingUp className="w-4 h-4" />
                ) : (
                  <TrendingDown className="w-4 h-4" />
                )}
                {crypto.priceHistory.yearToDateChange}
              </div>
            </div>

            <div className="text-sm text-gray-400">
              Key Features:
              <ul className="list-disc list-inside mt-1 space-y-1">
                {crypto.keyFeatures.slice(0, 2).map((feature, index) => (
                  <li key={index} className="text-gray-300">{feature}</li>
                ))}
              </ul>
            </div>

            <div className="flex justify-between items-center pt-2 border-t border-gray-800">
              <div className="text-sm text-blue-400 flex items-center gap-1">
                <Info className="w-4 h-4" />
                Click for details
              </div>
              <div className="text-xs text-gray-400">{crypto.category}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}